module.exports = __webpack_public_path__ + "static/media/Background2.126bbbfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Background2.png
// module id = 75
// module chunks = 0